/**
 * @file Expert dashboard UI — pages/Dashboard/Expert/Submissions/components/EmptyState.tsx.
 */

import React from "react";

const EmptyState: React.FC = () => {
  return (
    <div className="expert-empty" role="status" aria-live="polite">
      <div className="empty-icon" aria-hidden="true">
        <svg width="58" height="58" viewBox="0 0 60 60" focusable="false">
          <g fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="9" y="16" width="42" height="30" rx="6" ry="6" />
            <path d="M9 24h42" />
            <circle cx="20" cy="38" r="3" />
            <path d="M27 40h18" />
          </g>
        </svg>
      </div>
      <h3 className="empty-title">No submissions yet</h3>
      <p className="empty-desc">You will see datasets here as soon as contributors add them.</p>
    </div>
  );
};

/** React component — Empty State. */
export default EmptyState;

